"use client"

import { useSyncExternalStore } from "react"
import {
    OPEN_SETTINGS_EVENT,
    getConsentSnapshot,
    getServerConsentSnapshot,
    subscribeConsent,
} from "@/lib/analytics"
import { useConsentServices } from "@/components/analytics/analytics-config"

/** Footer link that reopens the consent banner. Renders nothing when analytics and maps are both off. */
export default function CookieSettingsLink() {
    const { measurementId, mapsEnabled } = useConsentServices()
    // "pending" on the server and during hydration, so nothing renders until mounted.
    const state = useSyncExternalStore(subscribeConsent, getConsentSnapshot, getServerConsentSnapshot)
    if (state === "pending" || measurementId === "" && !mapsEnabled) return null
    return (
        <button
            type="button"
            onClick={() => window.dispatchEvent(new Event(OPEN_SETTINGS_EVENT))}
            className="ml-3 underline underline-offset-2 hover:no-underline focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2"
        >
            Cookie settings
        </button>
    )
}
